import { createSelector } from "reselect";

export const getWaitList = state => state.waitList;
export const getApplications = state => state.waitList && state.waitList.applications;

export const isLoading = createSelector(
  getWaitList,
  waitList => waitList.isLoading,
);
